import './QualitativeIndicatorUnit.css';

import { Workspaces } from '@mui/icons-material';
import { Box } from '@mui/material';
import { generateClassName } from '../../../b2b-common/helpers';

const QualitativeIndicatorUnit = ({ indicator, showIcon = true, className = null }) => {
    return (
        <Box className={generateClassName('qualitative-indicator-unit','',className)} display="flex" flexDirection="row" alignItems="center" justifyContent="flex-start" gap={1}>
            {showIcon && (
                <Workspaces />
            )}
            <Box className="qualitative-indicator-unit-name" display="flex" flexDirection="row" alignItems="center" justifyContent="center">
                {indicator.qualitativeTypeDTO.qualitativeTypeName}
            </Box>
        </Box>
    );
}

export default QualitativeIndicatorUnit;